import {useAddNotification} from '@yandex-delivery/blocks'
import {setHandleError} from '@yandex-delivery/blocks/usetransition/useTransition'
import type {ServerError} from '@yandex-delivery/core/utils/network'
import {get, getErrorMessage} from '@yandex-delivery/utils'
import {useEffect, useRef} from 'react'

import {UnannouncedError} from './UnannouncedError'

export const HandleError = () => {
  const addNotification = useAddNotification()

  const isMounted = useRef<boolean>(false)

  if (!isMounted.current) {
    const newHandleError = (error?: unknown) => {
      if (error) {
        // Не оповещаем пользователя об ошибках UnannouncedError
        if (error instanceof UnannouncedError) {
          return
        }

        const errorMessage = getErrorMessage(error as Error)
        const yatraceId = get('headers.x-yatraceid', error as ServerError)
        let notificationMessage = errorMessage
        if (yatraceId) {
          notificationMessage += `\nX-Yatraceid: ${yatraceId} `
        }
        addNotification(notificationMessage, {
          type: 'error',
        })
      }
    }

    setHandleError(newHandleError)

    isMounted.current = true
  }

  useEffect(
    () => () => {
      setHandleError(undefined)
    },
    [],
  )

  return null
}
